import React from 'react';
import { Typography } from '@mui/material';
import PublicPage from './PublicPage';
import WaitlistForm from './WaitlistForm';
import { WAITLIST_COPY as COPY } from './waitlistCopy';

const PLACES = ['landing', 'sign_in', 'refused'];

/**
 * /waitlist (DWLF-584): the invite-only explanation and the sign-up. `?from=` says which prompt
 * brought the person here (landing, sign_in or refused); `?email=` pre-fills the address.
 */
export default function WaitlistPage({ search = window.location.search }) {
  const params = new URLSearchParams(search);
  const from = params.get('from');
  return (
    <PublicPage>
      <Typography component="h1" sx={{ fontFamily: '"Space Grotesk", sans-serif', fontWeight: 500, fontSize: { xs: '2rem', md: '2.5rem' }, letterSpacing: '-0.02em', mb: 2 }}>
        {COPY.heading}
      </Typography>
      <Typography sx={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: '0.95rem', lineHeight: 1.7, color: 'var(--dwlf-ink-70)', mb: 4 }}>
        {COPY.intro}
      </Typography>
      <WaitlistForm initialEmail={params.get('email') ?? ''} place={PLACES.includes(from) ? from : 'landing'} />
    </PublicPage>
  );
}
